// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ReceivedInvestmentTooltip_avatar__1h7HB","sending":"ReceivedInvestmentTooltip_sending__37d3r"};